import API_URL from "../config";
import axios from "axios";

import { getCookie } from "./../utils/cookies";

// export const getEventsPerformanceApi = async () => {
//   try {
//     const token = getCookie("T6hVzR7c0g3maM3F");
//     const iv = getCookie("02hfCmUqpk66w4uG");
//     const id = getCookie("3F2Mb2pJ1YRro5Z4");

//     const option = {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     };

//     const url = `${API_URL}/api/V2/event/events-performance/${id}/${iv}`;

//     const res = await axios.get(url, option);
//

//     return res.data;
//   } catch (err) {
//     console.error("Error in getEventsPerformanceApi:", err);
//     throw err;
//   }
// };

export const getEventsPerformanceApi = async (filters = {}) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const queryParams = new URLSearchParams();

    if (filters.category) {
      queryParams.append("category", filters.category);
    }
    if (filters.name) {
      queryParams.append("name", filters.name);
    }
    if (filters.date) {
      queryParams.append("date", filters.date);
    }
    const queryString = queryParams.toString();
    const baseUrl = `${API_URL}/api/V2/event/events-performance/${id}/${iv}`;
    const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;

    const res = await axios.get(url, option);

    return res.data;
  } catch (err) {
    console.error("Error in getEventsPerformanceApi:", err);
    throw err;
  }
};

export const getTop6EventsPerformanceApi = async () => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const url = `${API_URL}/api/V2/event/top6-performance/${id}/${iv}`;

    console.log("Calling backend endpoint for Top 6:", url);

    const res = await axios.get(url, option);

    console.log("Response data from getTop6EventsPerformanceApi:", res.data);

    return res.data;
  } catch (err) {
    console.error("Error in getTop6EventsPerformanceApi:", err);
    throw err;
  }
};

export const getDetailsLast6EventsApi = async () => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const url = `${API_URL}/api/V2/event/last6-details/${id}/${iv}`;

    console.log("Calling backend endpoint for Details of Last 6 Events:", url);

    const res = await axios.get(url, option);

    console.log("Response data from getDetailsLast6EventsApi:", res.data);

    return res.data;
  } catch (err) {
    console.error("Error in getDetailsLast6EventsApi:", err);
    throw err;
  }
};
export const getTop6EventsByRevenueApi = async () => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const url = `${API_URL}/api/V2/event/top6-revenue/${id}/${iv}`;

    console.log("Calling backend endpoint for Top 6 Revenue:", url);

    const res = await axios.get(url, option);

    console.log("Response data from getTop6EventsByRevenueApi:", res.data);

    return res.data;
  } catch (err) {
    console.error("Error in getTop6EventsByRevenueApi:", err);
    throw err;
  }
};
export const addNewEventImgsApi = async (formObjectData, eventID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const formData = new FormData();

    // Only append actual File objects — appending null sends the string "null" which multer ignores
    if (formObjectData?.eventMainImg instanceof File)
      formData.append("eventMainImg", formObjectData.eventMainImg);
    if (formObjectData?.eventCoverImg instanceof File)
      formData.append("eventCoverImg", formObjectData.eventCoverImg);
    if (formObjectData?.eventSiegesImg instanceof File)
      formData.append("eventSiegesImg", formObjectData.eventSiegesImg);

    // Append each image in the otherEventImgs array
    if (formObjectData?.otherEventImgs && Array.isArray(formObjectData.otherEventImgs)) {
      formObjectData.otherEventImgs.forEach((image) => {
        if (image instanceof File) formData.append("otherEventImgs", image);
      });
    }

    const res = await axios.post(
      `${API_URL}/api/V2/eventImg/create/${id}/${iv}/${eventID}`,
      formData,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const addNewEventApi = async (formValues) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const objectData = {
      eventTitle: formValues.eventTitle,
      promoVideo: formValues.promoVideo,
      address: formValues.address,
      description: formValues.description,
      eventPlace: formValues.eventPlace,
      eventCategory: formValues.eventCategory,
      eventSiege: formValues.eventSiege,
      eventStand: formValues.eventStand,
      socialLink: formValues.socialLink,
      onlineReservation: formValues.onlineReservation,
      isSelectetivePlaces: formValues.isSelectetivePlaces,
      seatIoId: formValues?.seatIoId,
      isSoldOut: false,
      isCinema: formValues.isCinema,
      isCirque: formValues.isCirque,
      eventDateList: (formValues.isCinema || formValues.isCirque) ? formValues.eventDateList : [],
    };

    if (!formValues.isCinema && !formValues.isCirque) {
      objectData.startDate = formValues.startDate;
      objectData.endDate = formValues.endDate;
      objectData.eventDate = formValues.eventDate;
      objectData.eventCloseDoorDate = formValues?.eventCloseDoorDate;
    } else {
      objectData.startDate = formValues.startDate;
      objectData.endDate = formValues.endDate;
      objectData.eventDate = formValues.eventDate;
      objectData.eventCloseDoorDate = formValues?.eventCloseDoorDate;
    }

    const res = await axios.post(`${API_URL}/api/V2/event/create/${id}/${iv}`, objectData, option);
    return res.data;
  } catch (err) {
    console.error("Error in addNewEventApi:", err);
    throw err;
  }
};

export const updateEventImgsApi = async (formObjectData, eventID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const formData = new FormData();

    // Only append actual File objects — appending null sends the string "null"
    if (formObjectData?.eventMainImg instanceof File)
      formData.append("eventMainImg", formObjectData.eventMainImg);
    if (formObjectData?.eventCoverImg instanceof File)
      formData.append("eventCoverImg", formObjectData.eventCoverImg);
    if (formObjectData?.eventSiegesImg instanceof File)
      formData.append("eventSiegesImg", formObjectData.eventSiegesImg);

    // Append each image in the otherEventImgs array
    if (formObjectData?.otherEventImgs && Array.isArray(formObjectData.otherEventImgs)) {
      formObjectData.otherEventImgs.forEach((image) => {
        if (image instanceof File) formData.append("otherEventImgs", image);
      });
    }

    const res = await axios.put(
      `${API_URL}/api/V2/eventImg/update/${id}/${iv}/${eventID}`,
      formData,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const updateEventApi = async (formValues, eventID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const objectData = {
      eventTitle: formValues.eventTitle,
      promoVideo: formValues.promoVideo,
      address: formValues.address,
      description: formValues.description,
      eventPlace: formValues.eventPlace,
      eventCategory: formValues.eventCategory,
      eventSiege: formValues.eventSiege,
      eventStand: formValues.eventStand,
      socialLink: formValues.socialLink,
      onlineReservation: formValues.onlineReservation,
      isSelectetivePlaces: formValues.isSelectetivePlaces,
      seatIoId: formValues?.seatIoId,
      isSoldOut: formValues.isSoldOut,
      isCinema: formValues.isCinema,
      isCirque: formValues.isCirque,
      city: formValues.city || "",
      eventDateList: (formValues.isCinema || formValues.isCirque) ? formValues.eventDateList : [],
    };

    if (!formValues.isCinema && !formValues.isCirque) {
      objectData.startDate = formValues.startDate;
      objectData.endDate = formValues.endDate;
      objectData.eventDate = formValues.eventDate;
      objectData.eventCloseDoorDate = formValues?.eventCloseDoorDate;
    } else {
      objectData.startDate = formValues.startDate;
      objectData.endDate = formValues.endDate;
      objectData.eventDate = formValues.eventDate;
      objectData.eventCloseDoorDate = formValues?.eventCloseDoorDate;
    }

    const res = await axios.put(
      `${API_URL}/api/V2/event/update/${id}/${iv}/${eventID}`,
      objectData,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

// export const getAllEventApi = async (publishedOnly, category,) => {
//   try {
//     const token = getCookie("T6hVzR7c0g3maM3F");
//     const iv = getCookie("02hfCmUqpk66w4uG");
//     const id = getCookie("3F2Mb2pJ1YRro5Z4");

//     const option = {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     };

//     let url = `${API_URL}/api/V2/event/read/${id}/${iv}`;

//     if (publishedOnly) {
//       url += `?publishedOnly=true`;
//     }

//     if (category) {
//       url += `${publishedOnly ? "&" : "?"}category=${category}`;
//     }

//     const res = await axios.get(url, option);
//     return res.data;
//   } catch (err) {
//     throw err;
//   }
// };

export const getAllEventTitleApi = async () => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const url = `${API_URL}/api/V2/event/eventsTitle/${id}/${iv}`;
    const response = await axios.get(url, option);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllEventApi = async (
  publishedOnly,
  category,
  eventTitle,
  selectedDate,
  page,
  limit
) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    let url = `${API_URL}/api/V2/event/read/${id}/${iv}`;

    let hasQueryParams = false;

    if (publishedOnly) {
      url += `?publishedOnly=true`;
      hasQueryParams = true;
    }

    if (category) {
      url += `${hasQueryParams ? "&" : "?"}category=${category}`;
      hasQueryParams = true;
    }

    if (eventTitle) {
      url += `${hasQueryParams ? "&" : "?"}eventTitle=${eventTitle}`;
      hasQueryParams = true;
    }
    if (selectedDate) {
      url += `${hasQueryParams ? "&" : "?"}eventDate=${selectedDate}`;
      hasQueryParams = true;
    }

    if (page) {
      url += `${hasQueryParams ? "&" : "?"}page=${page}`;
      hasQueryParams = true;
    }

    if (limit) {
      url += `${hasQueryParams ? "&" : "?"}limit=${limit}`;
    }

    const res = await axios.get(url, option);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getOneEventImgsApi = async (eventID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(
      `${API_URL}/api/V2/eventImg/readOne/${id}/${iv}/${eventID}`,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getOneEventApi = async (eventID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(`${API_URL}/api/V2/event/readOne/${id}/${iv}/${eventID}`, option);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getOneEventSiegeApi = async (eventID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(
      `${API_URL}/api/V2/event/readOne/eventSiege/${id}/${iv}/${eventID}`,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const deleteEventApi = async (eventID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.delete(`${API_URL}/api/V2/event/delete/${id}/${iv}/${eventID}`, option);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const publishEventApi = async (eventID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.put(
      `${API_URL}/api/V2/event/publish/${id}/${iv}/${eventID}`,
      {},
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const eventStatusApi = async (eventID, status) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.put(
      `${API_URL}/api/V2/event/status/${id}/${iv}/${eventID}/${status ? "active" : "inactive"}`,
      {},
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const eventSliderStatusApi = async (eventID, status) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.put(
      `${API_URL}/api/V2/event/sliderStatus/${id}/${iv}/${eventID}/${
        status ? "active" : "inactive"
      }`,
      {},
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const downloadOneEventTicketsExcelApi = async (eventID, selectedTimeId) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    let url = `${API_URL}/api/V2/event/getOneEventTicketsExcel/${id}/${iv}/${eventID}`;
    if (selectedTimeId && selectedTimeId !== "#ALL") {
      url += `?selectedTimeId=${selectedTimeId}`;
    }

    const res = await axios.get(url, option);

    return res.data;
  } catch (err) {
    throw err;
  }
};
export const downloadOneEventReservationExcelApi = async (eventID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const url = `${API_URL}/api/V2/event/getOneEventReservationExcel/${id}/${iv}/${eventID}`;

    const res = await axios.get(url, option);

    return res.data;
  } catch (err) {
    throw err;
  }
};
